import  tinycolor  from 'tinycolor2';

export const getColorWithOpacity = (tokenColor: string, opacity: number): string => {
  const color = new tinycolor(tokenColor);
  const colorWithOpacity = color.setAlpha(opacity);
  return colorWithOpacity.toRgbString();
};  